import React, { useState } from 'react';
import { AccordionItem } from './AccordionItem';
import './Accordion.scss';

type Data = {
  title: string;
  body: any;
};

interface AccordionProps {
  data: Data[];
  disabled?: number;
}

/**
 * ACRES Accordion:
 *
 ** Usage example: {www.google.com}
 *
 * @author Ton Tran <ton.tran@meijer.com>
 */

export const Accordion: React.FC<AccordionProps> = ({ data, disabled }) => {
  const [clicked, setClicked] = useState(null);

  const handleToggle = (index: any) => {
    if (clicked === index) {
      return setClicked(null);
    }
    setClicked(index);
  };
  return (
    <ul className="ads-accordion" data-testid="ads-accordion">
      {data.map((item, index) => (
        <AccordionItem
          key={index}
          title={item.title}
          body={item.body}
          onToggle={() => handleToggle(index)}
          active={clicked === index}
          disabled={disabled === index && true}
        />
      ))}
    </ul>
  );
};
